import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page78() {
  useEffect(() => {
    document.title = "Маяк — Страница 77"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page76" />
        <ForwardLink href="/page78" />
      </div>

      <p style={{ textAlign: "right" }}>77.</p>
      <p>
        Это ожесточенная борьба, когда он тащит ДОРИ<br/>
        по полозьям...
      </p>
      <p>МОЛОДОЙ бросает ВЕСЛА в лодку...</p>
      <p>Внезапно...</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        НЕ ОСТАВЛЯЙ МЕНЯ!
      </p>
      <p>
        СТАРИК ВЗМАХИВАЕТ В ВОЗДУХЕ ПОЖАРНЫМ ТОПОРОМ, РАЗБИВАЯ ДОРИ<br/>
        ПРЯМО ЗА МОЛОДЫМ!
      </p>
      <p>МОЛОДОЙ БЕЖИТ...</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ – НЕПРЕРЫВНО</p>
      <p>СТАРИК гонится за МОЛОДЫМ по острову, размахивая топором...</p>
      <p>МОЛОДОЙ бежит в ЖИЛЫЕ ПОМЕЩЕНИЯ.</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – НЕПРЕРЫВНО</p>
      <p>СТАРИК врывается и взмахивает ТОПОРОМ над МОЛОДЫМ, промахивается...</p>
      <p>
        СТАРИК заталкивает ТОПОР глубоко в кухонный стол. Падает<br/>
        от изнеможения. Они оба мокрые.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Ты сумасшедший сукин-сын! Ты<br/>
        разбил спасательную лодку!
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ты покинул свой пост!
      </p>
      <p>МОЛОДОЙ врывается в...</p>
      <br/>
      <p>ВНУТРИ. ГОСТИНАЯ – НЕПРЕРЫВНО</p>
      <p>
        ВОДА сильно течет с потолка. Она стекает вниз по одной<br/>
        из стен.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        И что ты сделаешь? Доложишь<br/>
        начальству?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Конечно! Я доложу о тебе,<br/>
        вызову инспектора--
      </p>
      <p style={{ textAlign: "right" }}>77.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page76" />
        <ForwardLink href="/page78" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710635430/the-lighthouse-script/man9e4una41tguciwkje.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page78;
